export const Actions = {
  LIST_LABEL_FORMATS: "LIST_LABEL_FORMATS",
  LIST_LABEL_FORMATS_SUCCEEDED: "LIST_LABEL_FORMATS_SUCCEEDED",
  LIST_POLICY_PRODUCTS: "LIST_POLICY_PRODUCTS",
  LIST_POLICY_PRODUCTS_SUCCEEDED: "LIST_POLICY_PRODUCTS_SUCCEEDED",
};
